import fetch from 'node-fetch';
import store from '@/store/index.js';

const generateApiUrl = (service, path, siteInfo = store.state.siteInfo) => {
  if (siteInfo.entry_site || !siteInfo.site_url || siteInfo.site_url === '') {
    return `/${siteInfo.site_preroute}/espacepersonnel/${service}/${path}`;
  }

  return `/${siteInfo.site_preroute}/espacepersonnel/${service}/${siteInfo.site_url}/${path}`;
};
const requestControllers = [];

async function cancelPendingRequests () {
  for (let i = requestControllers.length - 1; i >= 0; i--) {
    requestControllers[i].abort();
    requestControllers.splice(i, 1);
  }
}

async function makeApiRequest (path, method = 'GET', body = {}, impersonateToken = store.state.impersonateData) {
  const controller = new AbortController();
  requestControllers.push(controller);

  const params = {
    method: method,
    headers: { 'content-Type': 'application/json' },
    body: Object.keys(body).length !== 0 ? JSON.stringify(body) : undefined,
    signal: controller.signal
  };

  let url = path;

  if (impersonateToken) {
    if (url.includes('?')) {
      url = `${path}&impersonateData=${encodeURI(impersonateToken)}`;
    } else {
      url = `${path}?impersonateData=${encodeURI(impersonateToken)}`;
    }
  }

  console.log('[REQUEST]: ', path);

  return fetch(url, params)
    .then(response => response.json())
    .then(response => {
      console.log('[RESPONSE]: ', response);

      if (response.loginUrl) {
        store.commit('setLoading', true);

        window.location.href = response.loginUrl;
        throw (response);
      }

      return response;
    }).catch(err => err)
    .finally(() => {
      const index = requestControllers.findIndex(c => c.signal === controller.signal);
      if (index !== -1) {
        requestControllers.splice(index, 1);
      }
    });
}

// async function logout (siteInfo) {
//   // TO CHANGE
//   const site = await makeApiRequest(generateApiUrl('/api/site', siteInfo), 'GET');
//   if (!site.success) {
//     return null; // Loading and redirect to SSO
//   }

//   return site;
// }

async function getSiteInfo (siteInfo, impersonateToken) {
  // TO CHANGE
  const site = await makeApiRequest(generateApiUrl('api', 'site', siteInfo), 'GET', {}, impersonateToken);

  if (!site.success) {
    return null; // Loading and redirect to SSO
  }

  return site;
}

async function getUser (siteInfo) {
  const user = await makeApiRequest(generateApiUrl('api', 'user', siteInfo), 'GET');
  if (!user.success) {
    return null; // Loading and redirect to SSO
  }

  // Remove self user from contact
  store.commit('setUser', user.data);
  store.commit('setContacts', user.data.contacts);

  return user;
}

async function getAllowedProductsDetails (user) {
  const response = await makeApiRequest(generateApiUrl('api', 'user/participants/allowedProduct'), 'POST', { contacts: user.contacts, source: store.state.siteInfo.apiSource });

  if (response && response.success) {
    store.commit('setUser', { ...user, contacts: response.contacts });
    store.commit('setContacts', response.contacts);
  }

  return response;
}

async function getParticipantsDocuments (data) {
  const user = await makeApiRequest(generateApiUrl('api', 'user/participants/docs'), 'POST', data);
  if (!user.success) {
    return null;
  }

  return user;
}

async function getNewsletterSettings () {
  const settings = await makeApiRequest(generateApiUrl('api', 'newsletters-settings'), 'GET');

  if (!settings.success) {
    return {};
  }

  return settings;
}

async function getEbillets () {
  const orders = await makeApiRequest(generateApiUrl('api', `ebillets/${store.state.siteInfo.workspace}?source=${store.state.siteInfo.apiSource}`), 'GET');
  console.log('orders', orders);
  if (!orders.success) {
    return { eBillets: orders.data, status_code: orders.status_code };
  }
  return { eBillets: orders.data, status_code: orders.status_code };
}

async function getContracts () {
  const orders = await makeApiRequest(generateApiUrl('api', `contracts/${store.state.siteInfo.workspace}`), 'GET');
  if (!orders.success) {
    return {};
  }
  return orders.data;
}

async function getScheduledReservations (data) {
  await cancelPendingRequests();
  const scheduled = await makeApiRequest(generateApiUrl('api', 'reservations/scheduled'), 'POST', { ...data, source: store.state.siteInfo.apiSource });
  if (!scheduled.success) {
    return {};
  }
  return scheduled.data;
}

async function getActivities (data) {
  await cancelPendingRequests();
  const activities = await makeApiRequest(generateApiUrl('api', 'activities'), 'POST', { ...data, source: store.state.siteInfo.apiSource });
  if (!activities.success) {
    return {};
  }
  return activities.data;
}

async function reserveSession (data) {
  const reservation = await makeApiRequest(generateApiUrl('api', `reserver/${data.workspace}`), 'POST', data);
  return reservation.data;
}

async function clubPassReservation (data) {
  return makeApiRequest(generateApiUrl('api', `reserverClub/${store.state.siteInfo.workspace}`), 'POST', data);
}

async function exchangeSession (data) {
  const reservation = await makeApiRequest(generateApiUrl('api', `echanger/${data.workspace}`), 'POST', data);
  if (!reservation.success) {
    return {};
  }
  return reservation.data;
}

async function cancelReservation (data) {
  const cancelation = await makeApiRequest(generateApiUrl('api', `cancel/${data.workspace}`), 'POST', data);
  if (!cancelation.success) {
    return {};
  }
  return cancelation.data;
}

async function updateUser (data) {
  const user = await makeApiRequest(generateApiUrl('api', 'profile'), 'PUT', data);

  if (!user.success) {
    return null; // Loading and redirect to SSO
  }

  store.commit('setUser', user.data);

  return user;
}

async function associateParticipant (data) {
  console.log('data to update', data);
  const user = await makeApiRequest(generateApiUrl('api', 'associate/participant'), 'POST', data);
  if (!user.success) {
    return null; // Loading and redirect to SSO
  }

  store.commit('setContacts', user.data.contacts);

  return user;
}

// async function disassociateParticipant (data) {
//   console.log('data to update', data);
//   const user = await makeApiRequest(generateApiUrl('api', 'disassociate/participant'), 'POST', data);
//   if (!user.success) {
//     return null; // Loading and redirect to SSO
//   }

//   store.commit('setContacts', user.data.contacts);

//   return user;
// }

async function getStripeCustomerPortals (type) {
  store.commit('setLoading', true);
  const portal = await makeApiRequest(generateApiUrl('api', `create-stripe-portal/${store.state.siteInfo.workspace}/${store.state.user.stripe_id || store.state.user.uuid}/${type}`), 'GET');

  if (portal.success) {
    window.open(portal.data, '_blank');
  }

  store.commit('setLoading', false);
}

async function createContact (data, parent_uuid = undefined) {
  const user = await makeApiRequest(generateApiUrl('api', 'contact'), 'POST', { ...data, parent_uuid });

  return user;
}

async function updateContact (data) {
  const user = await makeApiRequest(generateApiUrl('api', 'contact'), 'PUT', data);

  return user;
}

async function updateNewsletters (data) {
  const user = await makeApiRequest(generateApiUrl('api', 'newsletters'), 'PUT', data);
  if (!user.success) {
    return null; // Loading and redirect to SSO
  }

  return user;
}

async function getDisplayContent () {
  const content = await makeApiRequest(generateApiUrl('api', `displaycontent/${store.state.siteInfo.workspace}`), 'GET');

  if (!content.success) {
    return {};
  }

  store.commit('setDisplayContent', content.data);

  return content;
}

async function isImpersonateMode (siteInfo = store.state.siteInfo) {
  return makeApiRequest(generateApiUrl('api', 'impersonateMode', siteInfo), 'GET');
}

async function getCustomerLicense (uuid, workspace) {
  return makeApiRequest(generateApiUrl('api', `user/license?uuid=${uuid}&workspace=${workspace}`), 'GET');
}

async function getCustomerInsurance (uuid, workspace) {
  return makeApiRequest(generateApiUrl('api', `user/insurance?uuid=${uuid}&workspace=${workspace}`), 'GET');
}

async function getPaymentLink (orderUuid, workspace) {
  return makeApiRequest(generateApiUrl('api', `payment-link?order_uuid=${orderUuid}&workspace=${workspace}`), 'GET');
}

async function getOrderPaymentLink (orderUuid, workspace) {
  const windowReference = window.open();
  const response = await makeApiRequest(generateApiUrl('api', `order-payment-link?order_uuid=${orderUuid}&workspace=${workspace}`), 'GET').then(resp => {
    if (resp.data) {
      windowReference.location = resp.data;
    }
  });
}

async function getPriceInfo ({ orderUuid }) {
  if (!orderUuid) {
    return { success: false, message: 'No order identifier' };
  }
  return makeApiRequest(generateApiUrl('api', `price-info?order_uuid=${orderUuid}`), 'GET');
}

async function getReceiptsInfo ({ orderUuid }) {
  if (!orderUuid) {
    return { success: false, message: 'No order identifier' };
  }
  return makeApiRequest(generateApiUrl('api', `recus?order_uuid=${orderUuid}`), 'GET');
}

async function getInvoicesInfo ({ orderUuid }) {
  if (!orderUuid) {
    return { success: false, message: 'No order identifier' };
  }
  return makeApiRequest(generateApiUrl('api', `factures?order_uuid=${orderUuid}`), 'GET');
}

async function orderRenewal (orderUuid, period, product) {
  return makeApiRequest(generateApiUrl('api', 'orderRenewal'), 'POST', { orderUuid, period, product });
}

async function getOrderProductAndPeriod (product, period) {
  return makeApiRequest(generateApiUrl('api', `orderProductPeriod?product=${product}&period=${period}&source=${store.state.siteInfo.apiSource}`), 'GET');
}

async function getCustomersReservations (args) {
  return makeApiRequest(generateApiUrl('api', 'amplify/reservedSession'), 'POST', args);
}

export {
  getCustomersReservations,
  getAllowedProductsDetails,
  getOrderProductAndPeriod,
  orderRenewal,
  getCustomerLicense,
  getCustomerInsurance,
  isImpersonateMode,
  makeApiRequest,
  getSiteInfo,
  getUser,
  getEbillets,
  getContracts,
  getScheduledReservations,
  updateUser,
  createContact,
  updateContact,
  updateNewsletters,
  associateParticipant,
  getActivities,
  reserveSession,
  clubPassReservation,
  cancelReservation,
  exchangeSession,
  getDisplayContent,
  getParticipantsDocuments,
  getPaymentLink,
  getPriceInfo,
  getReceiptsInfo,
  getInvoicesInfo,
  getOrderPaymentLink,
  getNewsletterSettings,
  getStripeCustomerPortals
};
